module.exports = __webpack_public_path__ + "img/sec4_5.560c0e34.png";